import { GoogleLogin, googleLogout } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useContext } from "react";
import emailContext from "./emailcontext";
import "./login.css";

function Login() {
    const [email, setEmail] = useContext(emailContext);
    function noth(){
        return;
    }
    return (
        <div className="login-page">
            <div className="login-card">
                <h2 className="login-heading">LOGIN</h2>
                <div className="login-button-row">
                    <GoogleLogin
                        theme="outline"
                        shape="pill"
                        size="large"
                        text="signin_with"
                        width="320"
                        onSuccess={(credentialResponse) => {
                            setEmail(jwtDecode(credentialResponse.credential).email);
                            // console.log(email)
                        }}
                        onError={() => {
                            console.log("Login Failed");
                        }}
                    />
                </div>
                {email?
        <button onClick={()=>{googleLogout();
            setEmail(undefined);
            localStorage.setItem("userEmail", email);
        }}>logout</button>:noth()}
            </div>
            {/* <button onClick={()=>console.log(email)}>hi</button>  */}
        </div>
        
    );
}
export default Login;